import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import { Z_INDEX } from "constants/constants";
import styled from "styled-components/macro";

export const ASKR_CUSTOM_URL_LS_KEY = "askr:customUrl";
export const ASKR_INGESTR_CUSTOM_URL_LS_KEY = "askrIngestr:customUrl";
export const MIDGARD_CUSTOM_URL_LS_KEY = "midgard:customUrl";

/** if using a custom Askr url (Settings page -> Advanced section), show an alert popup with a "revert" button */
const CustomAskrUrlIndicator = () => {
  const hideIndicatorFromUrl = window.location.search.includes(
    "hideLocalBanner=true"
  );
  const customAskrUrl = window.localStorage.getItem(ASKR_CUSTOM_URL_LS_KEY);
  const customAskrIngestrUrl = window.localStorage.getItem(
    ASKR_INGESTR_CUSTOM_URL_LS_KEY
  );
  const customMidgardUrl = window.localStorage.getItem(
    MIDGARD_CUSTOM_URL_LS_KEY
  );

  return hideIndicatorFromUrl ? null : (
    <>
      {customAskrUrl || customMidgardUrl || customAskrIngestrUrl ? (
        <CustomAskrUrlIndicatorStyles>
          <Alert
            severity="warning"
            action={
              <Button
                onClick={() => {
                  window.localStorage.removeItem(ASKR_CUSTOM_URL_LS_KEY);
                  window.localStorage.removeItem(
                    ASKR_INGESTR_CUSTOM_URL_LS_KEY
                  );
                  window.localStorage.removeItem(MIDGARD_CUSTOM_URL_LS_KEY);
                  window.location.reload();
                }}
                color="inherit"
                size="small"
              >
                REVERT & RELOAD
              </Button>
            }
          >
            {customAskrUrl ? (
              <>
                Using custom Askr url:{" "}
                <a
                  href={customAskrUrl.replace("graphql", "graphiql")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {customAskrUrl}
                </a>
                <br />
              </>
            ) : null}
            {customAskrIngestrUrl ? (
              <>
                Using custom Askr Ingestr url: {customAskrIngestrUrl}
                <br />
              </>
            ) : null}
            {customMidgardUrl ? (
              <>
                Using custom Midgard url:{" "}
                <a
                  href={customMidgardUrl.replace("graphql", "graphiql")}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {customMidgardUrl}
                </a>
              </>
            ) : null}
          </Alert>
        </CustomAskrUrlIndicatorStyles>
      ) : null}
    </>
  );
};

const CustomAskrUrlIndicatorStyles = styled.div`
  position: fixed;
  z-index: ${Z_INDEX.L10};
  bottom: 12px;
  right: 12px;
`;

export default CustomAskrUrlIndicator;
